export default __webpack_public_path__ + "static/AvisoPrivacidadAppAGN-8ebdf085dc004606fda7964d312e5458.pdf";